import {
  CLOSE_SERVICE_CASE,
  FETCH_SERVICE_CASE,
  FETCH_SERVICE_CASES,
  UPDATE_SERVICE_CASE,
  UNSET_FETCH_SERVICE_CASES,
  SET_FETCH_SERVICE_CASES,
  ADD_CONTACT_PROVIDED_SERVICE,
  UNSET_SERVICE_CASES_REFETCH,
  ADD_NOTE_INTERACTION,
  CREATE_SERVICE_CASE_SET_SUBMITTING,
  CREATE_SERVICE_CASE_UNSET_SUBMITTING,
  UPDATE_PROGRAM_INFORMATION,
  ADD_CASE_DOCUMENTS,
  REMOVE_CASE_DOCUMENT,
  RENAME_CASE_DOCUMENT,
} from 'src/actions';
import { replaceObjectInArrayById } from 'common/utils/stateHelpers';
import _ from 'lodash';

function getCaseInState({ caseId, contactId, state }) {
  return _.find(state[contactId], { id: caseId });
}

function findAndReplaceServiceCase(currentState, newData) {
  return _.reduce(currentState, (acc, curr) => {
    if (curr.id === newData.id) {
      return [...acc, newData];
    }
    return [...acc, curr];
  }, []);
}

const getCurrentContactState = (state, contactId) => {
  if (state[contactId] && state[contactId].data) {
    return state[contactId].data;
  }

  return state[contactId] || [];
};

export const defaultState = {
  isFetching: false,
  isCreating: false,
  refetch: false,
};

export default function serviceCaseReducer(state = defaultState, action) {
  const {
    caseId,
    contactId,
    documents,
    documentId,
    payload,
    title,
    type,
  } = action;
  const caseInState = getCaseInState({ caseId, contactId, state }) || {};

  switch (type) {
    case ADD_NOTE_INTERACTION:
    case ADD_CONTACT_PROVIDED_SERVICE:
      return { ...state, refetch: true };

    case UNSET_SERVICE_CASES_REFETCH:
      return { ...state, refetch: false };

    case FETCH_SERVICE_CASES:
      return _.assign({}, state, {
        [contactId]: {
          data: payload.data.data,
          paging: payload.data.paging,
        },
      });

    case FETCH_SERVICE_CASE: {
      const currentContactState = getCurrentContactState(state, contactId);
      const existingServiceCase = _.find(currentContactState, (sc) => sc.id === payload.data.data.id);

      if (existingServiceCase) {
        return _.assign({}, state, {
          [contactId]: findAndReplaceServiceCase(currentContactState, payload.data.data),
        });
      }

      return _.assign({}, state, {
        [contactId]: [
          ...currentContactState,
          payload.data.data,
        ],
      });
    }

    case UPDATE_PROGRAM_INFORMATION: {
      const currentContactState = getCurrentContactState(state, contactId);

      const newContactState = _.reduce(currentContactState, (acc, curr) => {
        if (curr.id === caseId) {
          return [...acc, { ...curr, program: payload.data.data }];
        }
        return [...acc, curr];
      }, []);

      return { ...state, [contactId]: newContactState };
    }

    case CLOSE_SERVICE_CASE:
    case UPDATE_SERVICE_CASE: {
      const currentContactState = getCurrentContactState(state, contactId);
      return _.assign({}, state, {
        [contactId]: findAndReplaceServiceCase(currentContactState, payload.data.data),
      });
    }

    case UNSET_FETCH_SERVICE_CASES:
      return { ...state, isFetching: false };

    case SET_FETCH_SERVICE_CASES:
      return { ...state, isFetching: true };

    case CREATE_SERVICE_CASE_SET_SUBMITTING:
      return { ...state, isCreating: true };

    case CREATE_SERVICE_CASE_UNSET_SUBMITTING:
      return { ...state, isCreating: false };

    // Case Documents
    case ADD_CASE_DOCUMENTS: {
      const currentContactState = getCurrentContactState(state, contactId);
      const updatedCases = findAndReplaceServiceCase(currentContactState, {
        ...caseInState,
        documents: [...caseInState.documents, ...documents],
      });

      return { ...state, [contactId]: updatedCases };
    }

    case REMOVE_CASE_DOCUMENT: {
      const currentContactState = getCurrentContactState(state, contactId);
      const updatedCases = findAndReplaceServiceCase(currentContactState, {
        ...caseInState,
        documents: _.reject(caseInState.documents, { id: documentId }),
      });

      return { ...state, [contactId]: updatedCases };
    }

    case RENAME_CASE_DOCUMENT: {
      const currentContactState = getCurrentContactState(state, contactId);
      const updatedCases = findAndReplaceServiceCase(currentContactState, {
        ...caseInState,
        documents: replaceObjectInArrayById({
          ..._.find(caseInState.documents, { id: documentId }),
          title,
        }, caseInState.documents),
      });

      return { ...state, [contactId]: updatedCases };
    }

    default:
      return state;
  }
}
